/**
 * Enhanced Cart Button Handler for Variant Thumbnails
 * Properly handles unavailable variants and hides the cart button
 */
(function() {
  document.addEventListener('DOMContentLoaded', initCompleteCartHandler);
  document.addEventListener('shopify:section:load', initCompleteCartHandler);
  
  function initCompleteCartHandler() {
    // Process each product card
    document.querySelectorAll('.product-card-wrapper, li[id^="Slide-"]').forEach(card => {
      // Find the cart form and button
      const cartForm = card.querySelector('.cart-btn-form');
      if (!cartForm) return;
      
      const variantInput = cartForm.querySelector('input[name="id"]');
      if (!variantInput) return;
      
      // Store original variant ID so we can restore it after hover
      cartForm.setAttribute('data-original-variant-id', variantInput.value);

      
      const cartButton = card.querySelector('.add-to-cart-btn');
      if (!cartButton) return;
      
      const cartContainer = card.querySelector('.card-product__add-to-cart');
      if (!cartContainer) return;
      
      // Track the currently clicked thumbnail
      let clickedThumbnail = null;
      
      // Get thumbnails in this card
      const thumbnails = card.querySelectorAll('.variant-thumb');
      if (!thumbnails.length) return;
      
      // Directly check each thumbnail's availability
      thumbnails.forEach(thumb => {
        // Explicitly check for "false" string or actual boolean false
        const isAvailable = thumb.getAttribute('data-available') === 'true';
        const variantId = thumb.getAttribute('data-variant-id');
        
        // Add a more visible indicator of availability status for debugging
        thumb.setAttribute('data-is-actually-available', isAvailable ? 'yes' : 'no');
        
                // Handle mouseenter for each thumbnail
        thumb.addEventListener('mouseenter', function() {
          // DON'T update variant ID on hover — only click should change what gets added to cart
          
          // Update cart button visibility based on this variant's availability
          if (isAvailable) {
            cartButton.disabled = false;
            cartButton.removeAttribute('disabled');
            cartContainer.style.display = '';
          } else {
            cartButton.disabled = true;
            cartButton.setAttribute('disabled', 'disabled');
            cartContainer.style.display = 'none';
          }
        });

        
        // Handle click on thumbnail
        thumb.addEventListener('click', function(e) {
          // Mark this as the clicked thumbnail
          thumbnails.forEach(t => t.classList.remove('clicked'));
          thumb.classList.add('clicked');
          clickedThumbnail = thumb;
          
          // Update button based on availability
          if (isAvailable) {
            cartButton.disabled = false;
            cartButton.removeAttribute('disabled');
            cartContainer.style.display = '';
          } else {
            cartButton.disabled = true;
            cartButton.setAttribute('disabled', 'disabled');
            cartContainer.style.display = 'none';
          }
        });
      });
      
      // Handle mouseleave for the entire thumbnails container
      const thumbsContainer = card.querySelector('.product__variant-thumbs-wrapper');
            if (thumbsContainer) {
        thumbsContainer.addEventListener('mouseleave', function() {
          if (clickedThumbnail) {
            // Restore the clicked thumbnail's variant ID and availability
            const clickedVariantId = clickedThumbnail.getAttribute('data-variant-id');
            const isClickedAvailable = clickedThumbnail.getAttribute('data-available') === 'true';
            if (clickedVariantId) variantInput.value = clickedVariantId;
            if (isClickedAvailable) {
              cartButton.disabled = false;
              cartButton.removeAttribute('disabled');
              cartContainer.style.display = '';
            } else {
              cartButton.disabled = true;
              cartButton.setAttribute('disabled', 'disabled');
              cartContainer.style.display = 'none';
            }
          } else {
            // No thumbnail clicked — restore original variant ID from the form's initial value
            const originalVariantId = cartForm.getAttribute('data-original-variant-id');
            if (originalVariantId) variantInput.value = originalVariantId;
            cartButton.disabled = false;
            cartButton.removeAttribute('disabled');
            cartContainer.style.display = '';
          }
        });
      }

      
      // Prevent cart submission for disabled buttons
      cartButton.addEventListener('click', function(e) {
        if (this.disabled || this.hasAttribute('disabled')) {
          e.preventDefault();
          e.stopPropagation();
          return false;
        }
      });
    });
  }
  
  // Run after a short delay
  setTimeout(initCompleteCartHandler, 500);
})();